/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * Editable field of a logbook entry. Travels as an int on the wire — never renumber.
 */
export type FacilityFlowCoreModulesFleetEntitiesVehicleLogbookField = typeof FacilityFlowCoreModulesFleetEntitiesVehicleLogbookField[keyof typeof FacilityFlowCoreModulesFleetEntitiesVehicleLogbookField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetEntitiesVehicleLogbookField = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
} as const;
